export var SubBlockType;
(function (SubBlockType) {
    SubBlockType["Divider"] = "divider";
    SubBlockType["Quote"] = "quote";
    SubBlockType["NewsCard"] = "news-card";
    /**
     * @deprecated Will be moved to params use BasicCard instead
     */
    SubBlockType["Partner"] = "partner";
    SubBlockType["PriceDetailed"] = "price-detailed";
    SubBlockType["MediaCard"] = "media-card";
    SubBlockType["BannerCard"] = "banner-card";
    /**
     * @deprecated Will be moved to params use BasicCard instead
     */
    SubBlockType["TutorialCard"] = "tutoral-card";
    /**
     * @deprecated Use LayoutItem
     */
    SubBlockType["CardWithImage"] = "card-with-image";
    SubBlockType["LayoutItem"] = "layout-item";
    SubBlockType["BackgroundCard"] = "background-card";
    SubBlockType["BasicCard"] = "basic-card";
    SubBlockType["Content"] = "content";
    SubBlockType["HubspotForm"] = "hubspot-form";
    /**
     * @deprecated Will be moved to params use BasicCard instead
     */
    SubBlockType["Card"] = "card";
})(SubBlockType || (SubBlockType = {}));
export const SubBlockTypes = Object.values(SubBlockType);
